import { PlayerMsgController } from "@quest/murka-games-behavior-panther";
import { GameParserModel } from "../Platform/GameParserModel";
import { ingenuity } from "@quest/base-core";

export class PlayerMsgControllerGame extends PlayerMsgController {
    /**
     * overrided to add basegame win amount in freegame amount
     */
    
    public showTotalWinMsgInFgBroken() {
        let totalFreeGameWin;
        if ((ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
          totalFreeGameWin = (ingenuity.parserModel as GameParserModel).getFreeSpinAccumulatedWinAmt() + (ingenuity.parserModel as GameParserModel).getBaseGameTotalWin() +  (ingenuity.parserModel as GameParserModel).getFishingTimeTotalWin();
        } else {
          totalFreeGameWin = (ingenuity.parserModel as GameParserModel).getFreeSpinWinAmt() + (ingenuity.parserModel as GameParserModel).getBaseGameTotalWin() +  (ingenuity.parserModel as GameParserModel).getFishingTimeTotalWin();
        }
        this.setValueInTotalWinMeter(totalFreeGameWin);
      }
}

